import classNames from 'classnames';
import { VideoPlayer } from '@/features/video-player';
interface Props {
  url: string;
  thumbnail?: string;
  className?: string;
}
export function Video({
  url,
  thumbnail,
  className
}: Props) {
  return <div className={classNames('homepage-container', className)} data-sentry-component="Video" data-sentry-source-file="video.tsx">
            <VideoPlayer url={url} thumbnail={thumbnail} className='mx-auto max-w-[508px] overflow-hidden rounded' showPlayIcon data-sentry-element="VideoPlayer" data-sentry-source-file="video.tsx" />
        </div>;
}